<template>
  <BaseBanner
    :class="$b()"
    v-bind="bannerAttrs"
  >
    <div :class="$b('content')">
      <VisionIcon
        icon="sungod"
        :class="$b('sg-icon')"
        size="stretch"
      />
      
      <BaseHeading
        size="h1-lg"
        tag="h1"
        :class="$b('heading')"
      >
        The 2024 Vision Raise.
      </BaseHeading>

      <VisionIcon
        icon="certified-b-corp"
        :class="$b('b-corp-icon')"
        size="stretch"
      />
    </div>
  </BaseBanner>
</template>

<script>
export default {
  name: 'InvestHeroBanner',
  props: {
    image: {
      type: Object,
      required: true
    },

    mobileImage: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    bannerAttrs () {
      return {
        aspectRatio: '16:9',
        image: this.image,
        mobileImage: this.mobileImage,
        overlayOpacity: 0,
        mobileOverlayOpacity: 0,
        fullWidth: true,
        bannerHeightAuto: false,
        matchHeightToContent: true,
        minHeight: '80vh',
        contentAlignment: 'center',
        disableParallax: false,
        isFirst: true
      }
    }
  }
}
</script>

<style lang="postcss">
.InvestHeroBanner {
  @apply mx-0 mt-[30px] smMax:mt-[60px];

  &.BaseBanner--full-width .BaseBanner__content {
    @apply grow md:py-lg;
    max-width: 1750px;

    padding-top: calc(2 * var(--outer-gutter));
  }
}

.InvestHeroBanner__heading {
  @apply text-white;

  text-shadow: 0 0 50px black;
  font-weight: 600;

  font-size: 50px;

  @screen md {
    font-size: 72px;
  }
}

.InvestHeroBanner__content {
  @apply flex flex-col justify-between
    h-full;

  @screen mdMax {
    @apply justify-start;
  }
}

.InvestHeroBanner {
  .InvestHeroBanner__sg-icon {
    @apply block mdMax:mb-md h-[130px] w-[130px];
  
    svg {
      height: 100% !important;
    }
  }
  
  .InvestHeroBanner__b-corp-icon {
    @apply block mdMax:mt-auto h-[100px] w-[100px];
    
    svg {
      height: 100% !important;
    }
  }
}
</style>
